module.exports = __webpack_public_path__ + "static/media/icon-user-management.cf72afcb.svg";